import { BasicPage } from "../../components/base/BasicPage";

export const SettingsPage = () => {
  return <BasicPage title="Settings Page" icon="" />;
};
